import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../features/auth/context/AuthContext";
import { useAppText } from "../../i18n";

const PrivateRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAuthLoading, isAdmin } = useAuth();
  const t = useAppText();

  if (isAuthLoading) {
    return (
      <div
        className="flex items-center justify-center min-h-screen gap-3 text-on-surface-variant"
        role="status"
        aria-live="polite"
      >
        <span className="material-symbols-outlined animate-spin text-2xl">progress_activity</span>
        <span className="text-sm">{t.common.loading}</span>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" />;
  // Session 21: admin-only Routes (Master-Data). Flip-Punkt fuer spaetere
  // Oeffnung auf alle User: die requireAdmin-Prop auf den betroffenen
  // Routes entfernen + Server-Middleware von "admin" auf "user" aendern.
  if (requireAdmin && !isAdmin) return <Navigate to="/dashboard" />;
  return children;
};

export default PrivateRoute;
